export const blobFromString = (str: string, type: string) => new Blob([str], { type })

/*
 * - create a link element for given blob
 * - ... and click it to download the blob
 */
export const downloadBlob = (blob: Blob, filename: string) => {
  const blobUrl = URL.createObjectURL(blob)
  const alink = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
  alink.setAttribute('href', blobUrl)
  alink.setAttribute('download', filename)
  alink.click()
  URL.revokeObjectURL(blobUrl)
}
